import {
  ReviewStatInterface,
  SimpleStatDistributionInterface,
  SimpleStatRatingInterface,
} from '@sport-activities/sdk';

export class ReviewStat implements ReviewStatInterface {
  public averageAttributeRating: SimpleStatRatingInterface[];
  public averageRating: number;
  public count: number;
  public percentageDelighted: number;
  public percentageSatisfied: number;
  public percentageUnsatisfied: number;
  public ratingDistribution: SimpleStatDistributionInterface[];
  public recommendedCount: number;

  constructor(init: Partial<ReviewStat>) {
    Object.assign(this, init);
  }
}
